/**
 * @file onboardingSeen.js
 * @description Helper compartido para "marcar como visto" un paso de onboarding (spotlight
 * global de OnboardingTour.js, guía de BusinessSetupGuide.js, o el propio banner que navega
 * a la página del paso) en localStorage, por usuario — así no vuelve a aparecer aunque el
 * paso siga sin completarse.
 */

const seenKey = (userId, stepKey) => `onboardingSeen:${userId}:${stepKey}`;

export const isSeen = (userId, stepKey) => {
    try {
        return localStorage.getItem(seenKey(userId, stepKey)) === '1';
    } catch (e) {
        return false;
    }
};

export const markSeen = (userId, stepKey) => {
    try {
        localStorage.setItem(seenKey(userId, stepKey), '1');
    } catch (e) {
        /* localStorage no disponible (modo privado, etc.) — el paso podría reaparecer en
           la próxima carga, no es grave. */
    }
};
